import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CustomButton from './CustomButton/CustomButton';
import { Stack } from '@mui/material';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	p: 4,
	'@media (max-width: 600px)': {
		width: '90%',
	},
};

function PaymentMethodsPopUp({ open, handleClose }: any) {
	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Stack direction={'column'} alignItems={'center'} sx={style}>
				<Typography id="modal-modal-title" variant="h6" component="h2" fontWeight={'bold'}>
					Pay Now with Ease!
				</Typography>
				<Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
					Use your payment app (PhonePe, Google Pay, Paytm, etc.) <br />
					to scan the QR code from your Digital Retail Partner and finish your payment.
				</Typography>
				<Typography sx={{ mt: 1, mb: 1 }}>✔️ Quick and hassle-free!</Typography>
				<Stack direction={'row'} mt={1} width={'100%'}>
					<CustomButton
						title={'Okay'}
						handleClick={handleClose}
						color="primary"
						styles={{
							width: '100%',
						}}
					/>
				</Stack>
			</Stack>
		</Modal>
	);
}

export default PaymentMethodsPopUp;
